"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataRefDataType = void 0;
/**
 * Code/type used to resolve a DataRef.
 * Generally managed by some authoring element, usually ScopedDataDefinition. (See $fanggle/projects/authoring-elements/src/models/org-level-constructs/scoped-data-definitions)
 *
 */
var DataRefDataType;
(function (DataRefDataType) {
    /**
     * Redis HASH type (eg, redis.hset)
     *
     * Namespace is used as the name of the hash (the first arg of HSET or HGETALL) with
     *  the dataRef.key used as the second item-level arg. Some app-level methods accept '*' to indicate hgetall is desired.
     */
    DataRefDataType["RedisHash"] = "RedisHash";
    /**
     * Redis plain/single item. (eg, redis.set)
     * Namespace must be blank/undefined.
     *
     */
    DataRefDataType["RedisItem"] = "RedisItem";
    /**
     * Redis LIST type (eg, redis.lpush)
     * Key(?!) is left blank/undefined.
     */
    DataRefDataType["RedisList"] = "RedisList";
    /**
     * Redis SET type (eg, redis.zadd)
     * https://redis.io/commands#sorted_set
     *
     */
    DataRefDataType["RedisSortedSet"] = "RedisSortedSet";
    /**
     * Redis redlock, for distributed locks.
     */
    DataRefDataType["Redlock"] = "Redlock";
    /**
     * Object store like AWS S3 or DigitalOcean Spaces.
     * Namespace is the URL to the store, key is the path/key within the store
     */
    DataRefDataType["ObjectStore"] = "ObjectStore";
    //
    // /**
    //  * Amazon S3 object
    //  * Namespace is S3 "bucket", key for rest of the S3 object location
    //  */
    // AwsS3 = 'AmazonS3',
    //
    //
    // /**
    //  * DigitalOcean object store
    //  *
    //  */
    // DigitalOceanObject = 'DigoObject'
})(DataRefDataType = exports.DataRefDataType || (exports.DataRefDataType = {}));
//# sourceMappingURL=data-ref-types.js.map